module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHBAMAAADZviHeAAAAG1BMVEUAAACyt8Wyt8SxtsOyuMSwtca/v7+yt8Oyt8TVbRWkAAAACHRSTlMA5K2JZC0IwI4Q/SkAAAAcSURBVAjXY2BgCGJgSO5gYJHoYKjoANMgPkgcAEdcBUtOC9K8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/Bottom/jiantou.png
// module id = 1bYG
// module chunks = 41